var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 3H13.25V1.5C13.25 1.10218 13.092 0.720644 12.8107 0.43934C12.5294 0.158035 12.1478 0 11.75 0L7.25 0C6.85218 0 6.47064 0.158035 6.18934 0.43934C5.90804 0.720644 5.75 1.10218 5.75 1.5V3H2V4.5H3.5V15.75C3.5 16.3467 3.73705 16.919 4.15901 17.341C4.58097 17.7629 5.15326 18 5.75 18H13.25C13.8467 18 14.419 17.7629 14.841 17.341C15.2629 16.919 15.5 16.3467 15.5 15.75V4.5H17V3ZM7.25 1.5H11.75V3H7.25V1.5ZM14 15.75C14 15.9489 13.921 16.1397 13.7803 16.2803C13.6397 16.421 13.4489 16.5 13.25 16.5H5.75C5.55109 16.5 5.36032 16.421 5.21967 16.2803C5.07902 16.1397 5 15.9489 5 15.75V4.5H14V15.75Z",
    fill: "#ED3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.5H7.25V13.5H8.75V7.5Z",
    fill: "#ED3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 7.5H10.25V13.5H11.75V7.5Z",
    fill: "#ED3939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrash);
export default __webpack_public_path__ + "static/media/redTrash.43444de914dd09b0c009cbd3c2c8be27.svg";
export { ForwardRef as ReactComponent };